import { DialogContent, DialogTitle } from "@mui/material";
import { Form } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNomenclatures } from "../../../../actions/providedServices";
import { StyledDialog } from "../../../styled/dialog";
import CustomDialog from "../../dialog/customDialog";
import FormikActions from "../../formik/formikActions";
import FormikForm from "../../formik/formikForm";
import { serviceFormValidationSchema } from "./formValidation";
import ServiceForm from "./serviceForm";

const initialValues = {
  id: null,
  art: "",
  prestador: "",
  subnomenclador: "",
  prestacion: "",
  nombre: "",
  descripcion: "",
  habilitada: false,
}

const serviceFormContainer = ({ open, handleClose, handleSubmit, serviceToEdit, loading }) => {
  const dispatch = useDispatch();
  const art = useSelector((state) => state.arts);
  const [loadingInternal, setLoadingInternal] = useState(true);
  const [formInitialValues, setFormInitialValues] = useState(initialValues);
  const [firstLoading, setFirstLoading] = useState(true);

  useEffect(() => {
    if (serviceToEdit) {
      if (serviceToEdit.artId) {
        Promise.all([dispatch(getNomenclatures(serviceToEdit.artId))]).finally(() => {
          setFirstLoading(false);
        });
      }
      setFormInitialValues({
        id: serviceToEdit.id,
        art: serviceToEdit.artId,
        subnomenclador: serviceToEdit.subnomenclador,
        prestacion: serviceToEdit.prestacion,
        nombre: serviceToEdit.nombrePrestacion,
        descripcion: serviceToEdit.descripcionPrestacion,
        habilitada: serviceToEdit.habilitada,
      })
    } else {
      setFormInitialValues(initialValues);
      setFirstLoading(false);
    }
  }, [serviceToEdit])

  useEffect(() => {
    if (!open) {
      setLoadingInternal(true);
      setFirstLoading(true);
    } else {
      setLoadingInternal(art.isFetching || firstLoading);
    }
  }, [art, firstLoading, open])

  return (
    <>
      <CustomDialog
        open={open}
        onClose={handleClose}
        scroll="paper"
      >
        <DialogTitle>
          {serviceToEdit ? "Editar Prestación" : "Agregar Prestación"}
        </DialogTitle>
        <FormikForm
          initialValues={formInitialValues}
          enableReinitialize
          onSubmit={handleSubmit}
          validationSchema={serviceFormValidationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <DialogContent >
                <StyledDialog.Container>
                  <ServiceForm
                    loading={loadingInternal || loading}
                    editing={!!serviceToEdit}
                  />
                </StyledDialog.Container>
              </DialogContent>
              <StyledDialog.Actions>
                <FormikActions
                  handleCancel={handleClose}
                  submitText="Aceptar"
                  disabled={loadingInternal || loading}
                />
              </StyledDialog.Actions>
            </Form>
          )}
        </FormikForm>
      </CustomDialog>
    </>
  )
}

export default serviceFormContainer;